var map = {
	"./template.betprofessor": 1512,
	"./template.betprofessor.tsx": 1512,
	"./template.betroyale": 1513,
	"./template.betroyale.tsx": 1513,
	"./template.default": 667,
	"./template.default.tsx": 667,
	"./template.fiestabet": 1514,
	"./template.fiestabet.tsx": 1514,
	"./template.goldenbet888": 1515,
	"./template.goldenbet888.tsx": 1515,
	"./template.goldrenrush": 1516,
	"./template.goldrenrush.tsx": 1516,
	"./template.puntcity": 1517,
	"./template.puntcity.tsx": 1517,
	"./template.puntgenie": 1518,
	"./template.puntgenie.tsx": 1518,
	"./template.questbet": 1519,
	"./template.questbet.tsx": 1519,
	"./template.sterlingparker": 1520,
	"./template.sterlingparker.tsx": 1520,
	"./template.ts": 980,
	"./template.vikingbet": 1521,
	"./template.vikingbet.tsx": 1521,
	"./template.volcanobet": 1522,
	"./template.volcanobet.tsx": 1522,
	"./template.wellbet": 1523,
	"./template.wellbet.tsx": 1523
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2443;